(() => {
  if (customElements.get('dw-delivery-estimate')) return;

  const FORMATS = {
    short: { weekday: 'short', month: 'short', day: 'numeric' },
    numeric: { day: '2-digit', month: '2-digit' },
    long: { weekday: 'long', month: 'long', day: 'numeric' },
  };

  const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

  const addDays = (date, days, skipWeekends) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!skipWeekends || !isWeekend(d)) added += 1;
    }
    return d;
  };

  class DwDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('[data-dw-text]');
      if (!text) return;

      const cutoff = Number(this.dataset.cutoff ?? 14);
      const minDays = Number(this.dataset.minDays ?? 5);
      const maxDays = Math.max(minDays, Number(this.dataset.maxDays ?? 7));
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const locale = this.dataset.locale || document.documentElement.lang || 'en';
      const format = FORMATS[this.dataset.format] ?? FORMATS.short;

      const now = new Date();
      const afterCutoff = now.getHours() >= cutoff;
      const dispatch = new Date(now);
      if (afterCutoff) dispatch.setDate(dispatch.getDate() + 1);
      if (skipWeekends) while (isWeekend(dispatch)) dispatch.setDate(dispatch.getDate() + 1);

      const template = afterCutoff && text.dataset.textAfter ? text.dataset.textAfter : text.dataset.text;
      if (template && template !== text.innerHTML) text.innerHTML = template;

      let fmt;
      try {
        fmt = new Intl.DateTimeFormat(locale, format);
      } catch (e) {
        fmt = new Intl.DateTimeFormat('en', format);
      }
      const fromEl = text.querySelector('[data-dw-from]');
      const toEl = text.querySelector('[data-dw-to]');
      if (fromEl) fromEl.textContent = fmt.format(addDays(dispatch, minDays, skipWeekends));
      if (toEl) toEl.textContent = fmt.format(addDays(dispatch, maxDays, skipWeekends));
    }
  }

  customElements.define('dw-delivery-estimate', DwDeliveryEstimate);
})();
